import React, { Component } from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBJumbotron,  MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon, MDBBadge, MDBInput} from "mdbreact";
import Axios from 'axios'
import { Layout, Menu, Breadcrumb, Icon, Select, Input, Button ,Card   } from 'antd';
import { StarOutlined, StarFilled, StarTwoTone, CaretDownOutlined, UserOutlined } from '@ant-design/icons';
import Modalteachingschedule from './Modalteachingschedule';
import Modalcolor from './Modalcolor';
import Getteachet2 from './Getteachet2';
import Getteachet3 from './Getteachet3';
import Getprograme from './Getprograme';
import Swal from 'sweetalert2/dist/sweetalert2.js'





export default class Learncheck extends Component {
    
    constructor(props) {
        super(props);
        this.state = {

          thschedule:[],
          modal: false,
          term:'',
          type:'1',
          idemp:'',
          empcouncilcheck:[],
          empcouncilcheck2:[],
          showteachingschedule:[],
          showteachingscheduleall:[],
          dd3:'',
          teacher:'',
          major:'',
          justClicked: null,

          SUBJCODECHECK:[],

        };

        this.getteachingschedule = this.getteachingschedule.bind(this);
         
      }


      getteachingschedule() {

        setTimeout(() => {
           //ภายใน
             Axios.get('https://git.kpru.ac.th/FrontEnd_Tabian/load/showstudentschedule/'+this.props.term+'/'+this.props.major)
            .then(res => {
             console.log(res);
             //  this.setState({ bankname: res.data, loading: false })
             const data11 = res.data;
             const honor = data11.filter(({ SUBJCODE }) => SUBJCODE === this.props.SUBJCODE ); // ตรวจสอบเกียรตินิยม
             this.setState({ SUBJCODECHECK: honor})
           }) 

         }, 0);

     // this.getteachingscheduleall();
      }

      componentDidMount() {
       this.getteachingschedule();
      }

 
    render() {

        console.log(this.state.SUBJCODECHECK)
        return (
            <div className='text-center'>
               {this.state.SUBJCODECHECK.length > 0 ?<><MDBIcon icon="thumbs-up" className="green-text pr-3" /></>:<><MDBIcon icon="thumbs-down" className="red-text pr-3" /></>}

            
            </div>
        )
    }
}
